import $ from 'jquery';

class StripCallOut {
  constructor(element){
    this.$el = $(element);
    this.addPadding();
  }

  checkBoxHeight(){
    let $box = this.$el.find('.mobile-guttered.info');
    let boxHeight = $box.innerHeight();
    let offsetHeight = parseInt($box.css('margin-top'));

    //return padding
    return boxHeight + offsetHeight;
  }

  addPadding(){
    this.$el.css({'padding-bottom' : this.checkBoxHeight()});
  }

}

$('.call-out.strip-component').each((index, element)=>{
  if(!$(element).parent().hasClass('slide')){
    //make sure that this is a non-carousel strip call-out
    new StripCallOut(element);
  }
});
